import { FC } from 'react';

import { Box, capitalize, Typography } from '@mui/material';
import { useAppSelector } from 'hooks';
import { ProfessionRecommendationCard } from 'portfolio3/features/pdf/components/cards';
import { proforientationModel } from 'portfolio3/features/proforientation';
import { activeFormatSelector } from 'selectors/drawers';

const RecommendationProforientationSection: FC = () => {
  const recommendedIndustries = useAppSelector(
    proforientationModel.selectors.proforientationRecommendationSelectors.proforientation,
  );
  const format = useAppSelector(activeFormatSelector);

  const hasData = recommendedIndustries.length > 0;

  if (!hasData) {
    return null;
  }

  const industryNamesString = recommendedIndustries.map((industry) => capitalize(industry.name)).join(', ');
  return (
    <Box className="recommendation-proforientation">
      <Box marginTop="16px" className="recommendation-probes__content">
        {hasData && (
          <>
            <Typography variant="Paragraph LG/Regular">
              Тебе рекомендованы следующие отрасли:{' '}
              <Typography component="span" variant="Paragraph LG/Semi Bold">
                {industryNamesString}.
              </Typography>
            </Typography>

            <Typography variant="Paragraph LG/Regular" marginTop="16px">
              Ниже для&nbsp;тебя сформирован список отраслей, специальностей и&nbsp;колледжей.
            </Typography>

            <Box
              display="grid"
              gridTemplateColumns={format === 'horizontal' ? '1fr 1fr' : '1fr'}
              gap="16px"
              marginTop="16px"
            >
              {recommendedIndustries.map((recommendation) => {
                return <ProfessionRecommendationCard key={recommendation.name} recommendation={recommendation} />;
              })}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default RecommendationProforientationSection;
